module.exports = __webpack_public_path__ + "static/media/studentIcon.62435902.png";